module.exports = __webpack_public_path__ + "static/media/pln.813d5403.png";